import BaseDataManager from './base';

const CriteriaTitles = {
    BentoBox: {
        WhiteCollar: 'White Collar',
        Exec: 'Execs',
        BlueCollar: 'Blue Collar',
        Owner: 'Owners',
    },
    TargetingTitles: {
        PropertyDeveloper: 0,
        PoliceOfficer: 1,
        MedicalLabTechnician: 2,
        TransportationWorker: 3,
        Tradespeople: 4,
        InteriorDesigner: 5,
        ConstructionWorker: 6,
        LandscaperGardener: 7,
        ExecutiveChef: 8,
        Farmer: 9,
        CLevel: 10,
        President: 11,
        VP: 12,
        Director: 13,
        Chairman: 14,
        ManagingDirector: 15,
        Principal: 16,
        Partner: 17,
        Founder: 18,
        Owner: 19,
        Lawyer: 20,
        Doctor: 21,
        Pharmacist: 22,
        TenuredProfessor: 23,
        ITManager: 24,
        BusinessAnalyst: 25,
        ManagementConsultant: 26,
        EngineerScientist: 27,
        HRManager: 28,
        Designer: 29,
        Accountant: 30,
        RegisteredNurse: 31,
        Pilot: 32,
        FinancialAdvisor: 33,
        OperationsManager: 34,
        InsuranceAgent: 35,
        MortgageBroker: 36,
    },
    TargetingTitlesNames: [
        'Property Developer',
        'Police Officer',
        'Medical Lab Technician',
        'Transportation Worker',
        'Tradespeople',
        'Interior Designer',
        'Construction Worker',
        'Landscaper/Gardener',
        'Executive Chef',
        'Farmer',
        'C-Level',
        'President',
        'VP',
        'Director',
        'Chairman',
        'Managing Director',
        'Principal',
        'Partner',
        'Founder',
        'Owner',
        'Lawyer',
        'Doctor',
        'Pharmacist',
        'Tenured Professor',
        'IT Manager',
        'Business Analyst',
        'Management Consultant',
        'Engineer and Scientist',
        'HR Manager',
        'Designer',
        'Accountant',
        'Registered Nurse',
        'Pilot',
        'Financial Advisor',
        'Operations Manager',
        'Insurance Agent',
        'Mortgage Broker',
    ],
    TargetingIndustry: {
        Law: 0,
        Medicine: 1,
        Internet: 2,
        BioTech: 3,
    },
    TargetingIndustryNames: ['Law', 'Medicine', 'Internet', 'Bio Tech'],
    TitlesMapping: {
        CLevel: 'CAO OR Chief Analytics Officer OR Chief Accounting Officer OR Chief Administrative Officer OR CAA OR Chief Applications Architect OR CDO OR Chief Design Officer OR Chief Digital Officer OR Chief Diversity Officer OR Chief Data Officer OR CEO OR Chief Executive Officer OR Chief Events Officer OR Chief Experience Officer OR CCO OR Chief Communications Officer OR Chief Contracting Officer OR Chief Compliance Officer OR Chief Commercial Officer OR Chief Creative Officer OR Chief Content Officer OR Chief Customer Officer OR Chief Development Officer OR CISO OR Chief Information Security Officer OR CIO OR Chief Information Officer OR Chief Investments Officer OR Chief Innovation Officer OR CITO OR Chief information Technological Officer OR CMO OR Chief Marketing Officer OR CPO OR Chief Product Officer OR Chief Procurement Officer OR Chief Privacy Officer OR Chief Process Officer OR CRO OR Chief Revenue Officer OR Chief Risk Officer OR CSO OR Chief Services Officer OR Chief Security Officer OR CTO OR Chief Technology Officer OR Chief Technical Officer OR CUO OR Chief Underwriting Officer OR COO OR Chief Operating Officer OR Chief Operations Officer OR CFO OR Chief Financial Officer OR CBO OR Chief Brand Officer OR Chief Business Officer OR CBDO OR Chief Business Development Officer OR CGO OR Chief Gaming Officer OR Chief Genealogical Officer OR CHRO OR Chief Human Resources Officer OR CKO OR Chief Knowledge Officer OR CLO OR Chief Learning Officer OR Chief Legal Officer OR Chief Reputation Officer OR Chief Research Officer OR Chief Restructuring Officer OR Chief Scientific Officer OR Chief Strategy Officer OR Chief Sustainability Officer OR CVO OR Chief Visibility Officer OR Chief Visionary Officer OR CWO OR Chief Web Officer',
        VP: 'Vice President OR Senior Vice President OR Associate Vice President OR VP OR SVP',
        Director:
            'Director OR Co-Director OR Assistant Director OR Operations Director OR Director of HR OR Director of Human Resources',
        Chairman: 'Chairman OR Vice Chairman OR Deputy Chairman',
        ManagingDirector: 'MD OR Managing Director',
        Partner: 'Partner OR managing partner OR senior partner',
        Founder: 'Founder OR Co-Founder OR cofounder',
        Owner: 'Owner OR Co-Owner OR board',
        ExecutiveChef: 'Head Chef OR Lead Chef OR sous chef OR chef',
        Lawyer: 'Senior Lawyer OR Advocate OR Counselor OR Attorney OR Barrister OR Procurator OR Solicitor OR Judge OR law partner',
        MedicalLabTechnician:
            'laboratory OR bioanalytical OR bioinformatics OR radiologic OR radiology OR biomedical OR stem cell OR computational chemistry OR health research OR analytical services OR physiologist OR biochemist OR chemist OR radiographer OR medical scientist OR medical technician OR medical technologist OR medical physicist OR medical researcher OR lab scientist OR lab technician OR lab technologist OR lab physicist OR lab researcher OR clinical scientist OR clinical technician OR clinical technologist OR clinical physicist OR clinical researcher OR forensic scientist OR forensic technician OR forensic technologist OR forensic physicist OR forensic researcher OR scientist technician OR scientist technologist',
        Doctor: 'Doctor OR Allergist OR Immunologist OR Anesthesiologist OR Cardiologist OR Dermatologist OR Endocrinologist OR Physician OR Gastroenterologist OR Hematologist OR Medical Geneticist OR Nephrologist OR Neurologist OR Obstetrician OR Gynecologist OR Oncologist OR Ophthalmologist OR Osteopath OR Otolaryngologist OR Pathologist OR Pediatrician OR Psychiatrist OR Podiatrist OR Pulmonologist OR Radiologist OR Rheumatologist OR Surgeon OR Urologist OR Occupational Therapist OR General Practitioner OR Sonographer OR GP OR Endodontist OR Veterinarian OR Dentist',
        Pharmacist: 'Pharmacy OR Pharmacist OR "Director of pharmacy" OR Toxicologist',
        TenuredProfessor: 'Professor OR Dean OR Assistant Dean OR University Professor',
        ITManager:
            'CIO OR Chief information officer OR VP of Systems Development OR Chief Security Officer OR CSO OR Chief Technology Officer OR CTO OR Systems architect OR Network Architect OR Information Security Officer OR "Director of IT" OR "Director of Information Technology" OR "Director of IS" OR "Director of Information Services" OR "Internet Services Manager" OR "IS Manager" OR tech lead OR scrum master OR Development Director OR Database Administrator OR Systems Developer OR technology officer OR Engineering lead OR Engineering Manager OR Engineering director OR security AND NOT "security guard"',
        BusinessAnalyst:
            'Business Analyst OR Project Manager OR Enterprise Architect OR Business Architect OR Enterprise Analyst OR Project Portfolio OR Research Analyst OR Market Analyst OR Market Research Analyst OR BI Analyst OR Business Value OR product manager OR Product Owner',
        ManagementConsultant:
            'Management Consultant OR Business Consultant OR Advertising Consultant OR Activation Consultant OR Compensation Consultant OR Consulting Advisor OR Creative Consultant OR Customer Service Improvement Consultant OR Cyber Security Strategy Consultant OR Economic Consultant OR Educational Consultant OR Financial Consultant OR Foreclosure Consultant OR Fundraising Consultant OR Healthcare Consultant OR Human Capital Consultant OR Human Resources Consultant OR Implementation Consultant OR Lactation Consultant OR Lead Consulting Engineer OR Legal Consultant OR Legal Nurse Consultant OR Marketing Consultant OR Marketing Data Consultant OR Medicaid/Medicare Consultant OR Political Campaign Consultant OR Political Consultant OR Political Strategist OR Recruitment Consultant OR Retail Sales Consultant OR Safety Consultant OR Sales Consultant OR Software Implementation Consultant OR Solutions Consultant OR Strategy Consultant OR Technology Consultant OR Websphere Consultant',
        EngineerScientist:
            'engineer OR engineering OR scientist OR "Director of Engineering" OR "engineering manager" OR "manager of engineering" OR Statistician OR Mathematician OR chemist OR Biologist OR Botanist OR Herpetologist OR Microbiologist OR Neuroscientist OR Zoologist OR physicist OR Geologist OR ecologist OR Archaeologist OR Astronaut OR Astronomer OR Biochemist OR Geographer OR Naturalist OR Oceanographer OR Paleontologist OR Pathologist OR bioinformatics OR computer programmer OR software developer OR molecular biologist OR Research and Development OR Researcher OR economist OR Sociologist OR Historian OR Anthropologist OR Urban planner OR psychologist OR inventor',
        HRManager: 'Human resources OR HR',
        Designer: 'designer OR Architect OR IXD OR Producer',
        Accountant:
            'Accountant OR accounting OR Audit Supervisor OR Auditor OR Bookkeeper OR Controller OR Financial Operations OR Audit Manager OR Tax Specialist OR CPA OR CGA OR CMA',
        Farmer: 'farmer OR farm OR farming OR Grain Broker OR Agricultural lender OR Crop Specialist OR Soil Scientist OR Plant Breeder OR Plant Geneticist OR Soil Surveyor OR Livestock Procurement OR Feedlot operator',
        RegisteredNurse:
            'nurse OR respiratory therapist OR Emergency Medical Technician OR Pharmacy Technician OR Surgical Technologist OR Midwife OR Psychiatric Technician',
        TransportationWorker:
            'driver OR transportation OR Supervisor OR Route Supervisor OR Scheduler OR Streetcar Operator OR Subway Operator OR Fleet Coordinator OR Fleet Manager OR Shuttle Car Operator OR Chauffeur OR Courier OR Dispatcher OR Expeditor OR Forklift Operator OR Fork lift operator OR Materials Control Manager OR Materials Handler OR Materials Handling Supervisor OR Materials Planner OR Package Handler OR Packaging Engineer OR Production Scheduler OR Refuse and Recyclable Material Collectors OR Traffic Clerk OR Traffic Director OR Traffic Manager OR Traffic analyst OR Rate analyst OR Traffic Supervisor OR Travel Coordinator OR Travel Manager OR Deck Officer OR Deckhand OR Marine Cargo Inspector OR Marine Oiler OR Marine Operator OR Merchant Mariners OR Motorboat Operator OR Sailor OR Air Traffic Controllers OR Airport Operations Crew Member OR Flight Attendant OR Flight Engineer OR Flight Instructor OR Gate Operations Staff OR Railway Engineer OR Railroad engineer OR Locomotive Engineer OR Rail Car Repairer OR Rail Yard Engineer OR Railroad Brake Operator OR Railroad Conductor OR Railway Conductor OR Railroad Yard Worker OR Train Crew Member OR Train Operator OR Yardmaster',
        Tradespeople:
            'Carpenter OR Plumber OR Electrician OR Crane Operator OR Welder OR Heavy OR Renovation Expert OR Machine Operator OR Site Manager OR electro mechanic OR industrial management OR Millwright OR machinist OR Finisher OR Plant Manager OR Tool Maker OR Elevator Repair OR Ironworker OR instrument technician OR Piping Designer',
        PoliceOfficer:
            'Police OR Detective OR Sergeant OR Constable OR Detective OR Head of Forensics OR Commissioner OR Deputy Chief OR Staff Superintendent OR Inspector OR Commander OR Lieutenant OR Corporal OR cadet OR Sheriff OR correctional OR corrections',
        Pilot: 'Aerial OR pilot OR flight OR airline OR aircraft OR airplane OR navigator OR flying OR Sky Marshall OR Avionics Technician OR First Officer OR Co-Pilot OR copilot OR co pilot OR captain OR Helicopter OR Air Traffic Controller OR Air Patrol OR Air Marshall',
        PropertyDeveloper:
            'Real Estate Developer OR Land Developer OR Director of Property Services OR Real Estate Manager OR Property Manager OR Lease Administrator OR Property Accountant OR property developer OR "commercial real estate" OR "corporate real estate" OR Chartered architect OR landscape architect OR Director Real Estate OR Director Property Management OR Director Asset Services OR commercial manager',
        OperationsManager:
            'import OR export OR logistics OR operations OR distribution OR estimating OR estimator OR equipment OR inventory OR shipping OR receiving OR logistician',
        FinancialAdvisor:
            'financial advisor OR financial adviser OR investment advisor OR investment adviser OR financial coach OR registered representative OR financial planner OR wealth planner OR wealth manager OR financial consultant OR family wealth manager OR investment advisor representative OR CFP OR ChFC OR Financial Advisor OR Senior Financial Advisor OR Independent Financial Advisor OR Financial Aid Advisor OR Financial Services Advisor OR Financial Planning Advisor OR Personal Financial Advisor OR Insurance Financial Advisor OR Financial Service Advisor OR Private Financial Advisor OR International Financial Advisor OR Advanced Financial Advisor OR Associate Financial Advisor OR Financial Advisors OR Investment Advisor OR Registered Investment Advisor OR Senior Investment Adviser OR Associate Investment Advisor OR Financial Planner OR Certified Financial Planner OR Senior Financial Planner OR Chartered Financial Planner OR Associate Financial Planner OR Wealth Management OR Wealth Manager OR Wealth Advisor OR Wealth management Advisor OR Senior Vice President Wealth Management OR Vice President of Wealth Management OR Director Wealth Management OR Private Wealth Advisor OR Private Wealth Management OR Head Of Wealth Management OR Senior Wealth Manager OR First Vice President Wealth Management OR Wealth Management Consultant OR Private Wealth Manager OR Wealth Management Intern OR Private Wealth Management Intern',
        InteriorDesigner:
            'Interior Documentor OR Space Planner OR Interior Architect OR Interior decorater OR interior decorator OR Aircraft interior designer OR Home Decorator OR Retail space planner OR Interior design project manager OR Home Stager OR Staging Consultant',
        ConstructionWorker:
            'Sheet metal worker OR Restoration Labour OR Building Inspector OR Construction Coordinator OR Ironworker OR Insulation worker OR Mason OR Foreman OR Builder',
        LandscaperGardener:
            'Landscaper OR Cemetery OR Golf Course Keeper OR Greenskeeper OR Horticulture Worker OR Irrigation Technician OR Landscape Management Technician OR park',
        InsuranceAgent:
            'Insurance Agent OR Life Insurance Agent OR Health Insurance Agent OR Commercial Insurance Agent OR Licensed Insurance Agent OR Independent Insurance Agent OR Insurance Sales Agent OR Life Health Insurance Agent OR Insurance Specialist OR Insurance Manager OR Insurance Consultant OR Insurance Officer OR Insurance Broker OR Health Insurance Specialist OR Director of Insurance OR Head Of Insurance OR Insurance Advisor OR Insurance Executive',
        MortgageBroker:
            'Mortgage Broker OR Mortgage Specialist OR Mortgage Advisor OR Home Mortgage Consultant OR Mortgage Manager OR Mortgage Agent OR Vice President Mortgage OR Senior Mortgage Loan Officer OR Senior Mortgage Banker OR Mortgage Consultant OR Mortgage Loan Officer OR Senior Mortgage Consultant OR Mortgage Professional',
        EXCLUSION:
            'NOT (financial advisor OR financial adviser OR investment advisor OR investment adviser OR financial coach OR insurance agent OR registered representative OR financial planner OR wealth planner OR wealth manager OR broker OR financial consultant OR family wealth manager OR investment advisor representative OR CFP OR ChFC OR Financial Advisor OR Senior Financial Advisor OR Independent Financial Advisor OR Financial Aid Advisor OR Financial Services Advisor OR Financial Planning Advisor OR Personal Financial Advisor OR Insurance Financial Advisor OR FInancial Service Advisor OR Private Financial Advisor OR International Financial Advisor OR Advanced Financial Advisor OR Associate Financial Advisor OR Financial Advisors OR Investment Advisor OR Registered Investment Advisor OR Senior Investment Adviser OR Associate Investment Advisor OR Financial Coach OR Insurance Agent OR Life Insurance Agent OR Health Insurance Agent OR Commercial Insurance Agent OR Licensed Insurance Agent OR Independent Insurance Agent OR Insurance Sales Agent OR Life Health Insurance Agent OR Registered Representative OR Financial Planner OR Certified Financial Planner OR Senior Financial Planner OR Chartered Financial Planner OR Associate Financial Planner OR Wealth Management OR Wealth Manager OR Wealth Advisor OR Wealth management Advisor OR Senio Pp r Vice President Wealth Management OR Vice President of Wealth Management OR Director Wealth Management OR Private Wealth Advisor OR Private Wealth Management OR Head Of Wealth Management OR Senior Wealth Manager OR First Vice President Wealth Management OR Wealth Management Consultant OR Private Wealth Manager OR Wealth Management Intern OR Private Wealth Management Intern OR Mortgage Broker OR Mortgage Specialist OR Mortgage Advisor OR Home Mortgage Consultant OR Mortgage Manager OR Mortgage Agent OR Vice President Mortgage OR Senior Mortgage Loan Officer OR Senior Mortgage Banker OR Mortgage Consultant OR Mortgage Loan Officer OR Senior Mortgage Consultant OR Mortgage Professional OR Insurance Specialist OR Insurance Manager OR Insurance Consultant OR Insurance Officer OR Insurance Broker OR Health Insurance Specialist OR Director of Insurance OR Head Of Insurance OR Insurance Advisor OR Insurance Executive)',
    },
};

export const TargetingGroups = [
    {
        Target: CriteriaTitles.BentoBox.WhiteCollar,
        Selection: [
            CriteriaTitles.TargetingTitles.Lawyer,
            CriteriaTitles.TargetingTitles.Doctor,
            CriteriaTitles.TargetingTitles.Pharmacist,
            CriteriaTitles.TargetingTitles.TenuredProfessor,
            CriteriaTitles.TargetingTitles.ITManager,
            CriteriaTitles.TargetingTitles.BusinessAnalyst,
            CriteriaTitles.TargetingTitles.ManagementConsultant,
            CriteriaTitles.TargetingTitles.EngineerScientist,
            CriteriaTitles.TargetingTitles.HRManager,
            CriteriaTitles.TargetingTitles.Designer,
            CriteriaTitles.TargetingTitles.Accountant,
            CriteriaTitles.TargetingTitles.RegisteredNurse,
            CriteriaTitles.TargetingTitles.FinancialAdvisor,
            CriteriaTitles.TargetingTitles.OperationsManager,
            CriteriaTitles.TargetingTitles.InsuranceAgent,
            CriteriaTitles.TargetingTitles.MortgageBroker,
        ],
    },
    {
        Target: CriteriaTitles.BentoBox.Exec,
        Selection: [
            CriteriaTitles.TargetingTitles.CLevel,
            CriteriaTitles.TargetingTitles.President,
            CriteriaTitles.TargetingTitles.Director,
            CriteriaTitles.TargetingTitles.VP,
        ],
    },
    {
        Target: CriteriaTitles.BentoBox.BlueCollar,
        Selection: [
            CriteriaTitles.TargetingTitles.PropertyDeveloper,
            CriteriaTitles.TargetingTitles.PoliceOfficer,
            CriteriaTitles.TargetingTitles.MedicalLabTechnician,
            CriteriaTitles.TargetingTitles.TransportationWorker,
            CriteriaTitles.TargetingTitles.Tradespeople,
            CriteriaTitles.TargetingTitles.InteriorDesigner,
            CriteriaTitles.TargetingTitles.ConstructionWorker,
            CriteriaTitles.TargetingTitles.LandscaperGardener,
            CriteriaTitles.TargetingTitles.ExecutiveChef,
            CriteriaTitles.TargetingTitles.Farmer,
            CriteriaTitles.TargetingTitles.Pilot,
        ],
    },
    {
        Target: CriteriaTitles.BentoBox.Owner,
        Selection: [
            CriteriaTitles.TargetingTitles.Chairman,
            CriteriaTitles.TargetingTitles.ManagingDirector,
            CriteriaTitles.TargetingTitles.Principal,
            CriteriaTitles.TargetingTitles.Partner,
            CriteriaTitles.TargetingTitles.Founder,
            CriteriaTitles.TargetingTitles.Owner,
        ],
    },
];

enum YearSelectionEnum {
    OneYear,
    OneTwoYears,
    ThreeFiveYears,
    SixTenYears,
    TenYears,
}

const YearSelectionName = [
    'Less than 1 year',
    '1 to 2 years',
    '3 to 5 years',
    '6 to 10 years',
    'More than 10 years',
];

export const YearSelectionList = [
    YearSelectionEnum.OneYear,
    YearSelectionEnum.OneTwoYears,
    YearSelectionEnum.ThreeFiveYears,
    YearSelectionEnum.SixTenYears,
    YearSelectionEnum.TenYears,
];

const CompanySizeEnum = {
    Self: 0,
    '1to10': 1,
    '11to50': 2,
    '51to200': 3,
    '201to500': 4,
    '501to1000': 5,
    '1001to5000': 6,
};

const CompanySizeName = [
    'Self Employed',
    '1 - 10',
    '11 - 50',
    '51 - 200',
    '201 - 500',
    '501 - 1000',
    '1001 - 5000',
];

export const CompanySizeList = [
    CompanySizeEnum.Self,
    CompanySizeEnum['1to10'],
    CompanySizeEnum['11to50'],
    CompanySizeEnum['51to200'],
    CompanySizeEnum['201to500'],
    CompanySizeEnum['501to1000'],
    CompanySizeEnum['1001to5000'],
];

class ConstantManager extends BaseDataManager {
    constructor() {
        super();
    }

    /**
     * Get all title criterias for campaign settings
     * @returns A promise resolving targeting models
     */
    public getTargetCriteriaTitles = () => {
        // When we have an ajax call, we should replace this with a get
        const result = TargetingGroups.map((t) => ({
            label: t.Target,
            options: t.Selection.map((s) => ({
                key: `${s}`,
                label: CriteriaTitles.TargetingTitlesNames[s],
                value: CriteriaTitles.TargetingTitlesNames[s],
            })),
        }));
        return Promise.resolve(result);
    };

    /**
     * Get all year period criteria for campaign settings'
     * @returns A promise resolving periods
     */
    public loadCriteriaYears = () => {
        const result = YearSelectionList.map((y) => ({
            key: `${y}`,
            label: YearSelectionName[y],
            value: YearSelectionName[y],
        }));
        return Promise.resolve(result);
    };

    /**
     * Get all conpany head count criterias for campaign settings
     * @returns A promise resolving company sizes
     */
    public loadCompanySize = () => {
        const result = CompanySizeList.map((s) => ({
            key: `${s}`,
            label: CompanySizeName[s],
            value: CompanySizeName[s],
        }));
        return Promise.resolve(result);
    };

    /**
     * Get all proxy options available
     */
    public loadProxies = (): Promise<{ [k: string]: string }> => {
        const url = this.combineRoute(this.BACKEND_ROUTES.SETTINGS.FE, 'proxies');
        return this.RequestManager.get<{ [k: string]: string }>(url).then(
            (response) => response.data
        );
    };
}

const instance = new ConstantManager();
export default instance;
